import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AppModal = ({
  open,
  isOpen,
  onClose,
  title,
  children,
  maxWidth = "md",
  fullWidth = true,
  contentSx = {},
}) => {
  // Support legacy 'isOpen' prop for backwards compatibility in case it's used as a loader
  const isActuallyOpen = open !== undefined ? open : isOpen;

  if (isOpen !== undefined && !title && !children) {
    // Legacy spinner use case fallback (if they haven't removed it from other files yet)
    return (
      <Dialog
        open={!!isActuallyOpen}
        PaperProps={{ style: { background: "transparent", boxShadow: "none" } }}
      >
        <div className="items-center justify-center flex">
          <div className="progress"></div>
        </div>
      </Dialog>
    );
  }

  return (
    <Dialog
      open={!!isActuallyOpen}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      scroll="paper"
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {title}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 2, ...contentSx }}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default AppModal;
